import ABCyaPhaser from "@abcya/abcya_phaser";
import gameData from "../gameData";
import FontKeys from "../FontKeys";
import ABCyaLib from "@abcya/abcya_lib";

export default class Planet extends Phaser.GameObjects.Container
{
    constructor(scene)
    {
        super(scene);
        scene.add.existing(this);

        this.setPosition(this.scene.mid.x - 100, this.scene.mid.y - 25);
		
        this.createItem();
    }

	createItem() {
        this.planet = ABCyaPhaser.Images.addImage(0, 0, "planet", this);

        this.linesCont = this.scene.add.container();
        this.add(this.linesCont);

        this.lines = ABCyaPhaser.Images.addImage(-this.planet.width/2, 0, "planetLines", this.linesCont).setOrigin(0, .5);
        this.lines2 = ABCyaPhaser.Images.addImage(this.lines.width + this.lines.x - 2, 0, "planetLines", this.linesCont).setOrigin(0, .5);
        
        this.txt = this.scene.add.container(this.x, this.y);
        const textPosition = ABCyaLib.Environment.instance.gameConfig.planetTitleTextPosition;
        const shadow = ABCyaPhaser.Text.addText(textPosition.x - 8 - this.x, textPosition.y - 4 - this.y, 190, 0x123828, FontKeys._ostrich_sansheavy, ABCyaPhaser.Localization.instance.getLocalizedString('planet_text'), this.txt).setAlpha(0.3).setAngle(-10.67);
        const text = ABCyaPhaser.Text.addText(textPosition.x - this.x, textPosition.y - this.y, 190, 0xfce6ca, FontKeys._ostrich_sansheavy, ABCyaPhaser.Localization.instance.getLocalizedString('planet_text'), this.txt).setAngle(-10.67);

        if(ABCyaLib.Environment.instance.locale === ABCyaLib.Environment.LOCALES.esUS) {
          shadow.setFontSize(117);
          text.setFontSize(117);
          const dePosition = {x: 415 - this.x, y: 301 - this.y};
          const preTextShadow = ABCyaPhaser.Text.addText(dePosition.x - 8, dePosition.y - 4, 68, 0x123828, FontKeys._ostrich_sansheavy, ABCyaPhaser.Localization.instance.getLocalizedString('planet_text_pre'), this.txt).setAlpha(0.3).setAngle(-10.67);
          const preText = ABCyaPhaser.Text.addText(dePosition.x, dePosition.y, 68, 0xfce6ca, FontKeys._ostrich_sansheavy, ABCyaPhaser.Localization.instance.getLocalizedString('planet_text_pre'), this.txt).setAngle(-10.67);

          if(!gameData.DESKTOP){ 
            preText.setPosition(287 - this.x, 426 - this.y);
            preTextShadow.setPosition(preText.x - 8, preText.y - 4);
          }
        }

        if(!gameData.DESKTOP){ 
          const mobileTextPosition = ABCyaLib.Environment.instance.gameConfig.mobilePlanetTitleTextPosition;
          text.setPosition(mobileTextPosition.x - this.x, mobileTextPosition.y - this.y);
          shadow.setPosition(mobileTextPosition.x - 8 - this.x, mobileTextPosition.y - 4 - this.y);
        }

        this.maskRef = this.scene.add.circle(this.x, this.y, 293, 0xff0000, 1).setAlpha(0);
        const masker = new Phaser.Display.Masks.GeometryMask(this.scene, this.maskRef);
        this.linesCont.mask = masker;

        this.spinPlanet();
	};

    spinPlanet(){
        this.linesCont.x = 0;

        ABCyaPhaser.Tweens.addTween(this.linesCont, 15000, {x:-this.lines.width}, Phaser.Math.Easing.Linear, ()=>{
            this.spinPlanet();
        });
    };

    tweenOut()
    {
      ABCyaPhaser.Tweens.addTween(this, 1000, {x:-400, onUpdate: ()=> {
        this.txt.setPosition(this.x, this.y);
        this.maskRef.setPosition(this.x, this.y);
      }}, Phaser.Math.Easing.Linear);
    };
}